import { Bundle } from "./bundle.model";

export class Course {
    gitURL: string;
    courseID: string;
    courseName: string;
    majorVersion: string;
    minorVersion: string;
    vcs: string;
    isCopy: boolean;
    bundleDto: Bundle;
}